// One department reference, one address (SEM-6329 / LINK_INVENTORY B).
//
// THE ADDRESS IS THE FILTERED ROSTER, NOT A DETAIL SCREEN. Three screens print
// a department name as dead text, and all three ask the reader the same
// question: who is in it? A department detail page would need a route, an
// endpoint and its own i18n, and its main panel would be that roster — the list
// `/people` already renders, already scoped to the caller by the server.
//
// `?department_id=` is a filter the people list has read since SEM-6350, so
// this address costs nothing new and is shareable and reloadable for free.
//
// TWO ROSTERS, NOT ONE. `/people` is the personnel list, and the server scopes
// it: a plain employee reads one row (their own) from it, so a department link
// that led there answered "who is in it?" with "you" (E27). The employee-facing
// screens therefore link to the directory roster (`surface="directory"`), which
// lists every active coworker. The surface is chosen by the CALLER, not sniffed
// here, so this file stays free of hooks and a link's address never depends on
// a query that may not have resolved yet.
//
// If a real department screen is ever built (budget, cost centre, sub-tree),
// this file is the one edit — that is the reason the path is not composed at
// the call sites.

import { EntityLink } from "./entity-link";

export function departmentPath(departmentId: string): string {
  return `/people?department_id=${encodeURIComponent(departmentId)}`;
}

export function directoryDepartmentPath(departmentId: string): string {
  return `/me/directory?department_id=${encodeURIComponent(departmentId)}`;
}

export interface DepartmentLinkProps {
  readonly departmentId: string | null | undefined;
  readonly children: React.ReactNode;
  readonly className?: string;
  /** Which roster the link opens. Defaults to the personnel list. */
  readonly surface?: "people" | "directory";
}

export function DepartmentLink({
  departmentId,
  children,
  className,
  surface = "people",
}: DepartmentLinkProps): React.ReactElement {
  return (
    <EntityLink
      entityId={departmentId}
      toPath={surface === "directory" ? directoryDepartmentPath : departmentPath}
      {...(className !== undefined && { className })}
    >
      {children}
    </EntityLink>
  );
}
